import * as React from "react";

interface Props {
  width: number
  height: number
}

const DocumentPowerpointIcon = ({ width = 800, height = 800, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={4.494}
        y1={-1748.086}
        x2={13.832}
        y2={-1731.914}
        gradientTransform="translate(0 1756)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ca4c28" />
        <stop offset={0.5} stopColor="#c5401e" />
        <stop offset={1} stopColor="#b62f14" />
      </linearGradient>
    </defs>
    <title>{"file_type_powerpoint"}</title>
    <path
      d="M18.93,17.3,16.977,3h-.146A12.9,12.9,0,0,0,3.953,15.854V16Z"
      style={{
        fill: "#ed6c47",
      }}
    />
    <path
      d="M17.123,3h-.146V16l6.511,2.6L30,16v-.146A12.9,12.9,0,0,0,17.123,3Z"
      style={{
        fill: "#ff8f6b",
      }}
    />
    <path
      d="M30,16v.143A12.905,12.905,0,0,1,17.12,29h-.287A12.907,12.907,0,0,1,3.953,16.143V16Z"
      style={{
        fill: "#d35230",
      }}
    />
    <path
      d="M17.628,9.389V23.26a1.2,1.2,0,0,1-.742,1.1,1.16,1.16,0,0,1-.45.091H7.027c-.182-.208-.358-.429-.521-.65a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85c.143-.221.293-.442.456-.65h9.93A1.2,1.2,0,0,1,17.628,9.389Z"
      style={{
        opacity: 0.10000000149011612,
        isolation: "isolate",
      }}
    />
    <path
      d="M16.977,10.04V23.911a1.15,1.15,0,0,1-.091.448,1.2,1.2,0,0,1-1.1.741H7.62q-.309-.314-.593-.65c-.182-.208-.358-.429-.521-.65a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.735A1.2,1.2,0,0,1,16.977,10.04Z"
      style={{
        opacity: 0.20000000298023224,
        isolation: "isolate",
      }}
    />
    <path
      d="M16.977,10.04V22.611A1.2,1.2,0,0,1,15.785,23.8H6.506a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.735A1.2,1.2,0,0,1,16.977,10.04Z"
      style={{
        opacity: 0.20000000298023224,
        isolation: "isolate",
      }}
    />
    <path
      d="M16.326,10.04V22.611A1.2,1.2,0,0,1,15.134,23.8H6.506a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.084A1.2,1.2,0,0,1,16.326,10.04Z"
      style={{
        opacity: 0.20000000298023224,
        isolation: "isolate",
      }}
    />
    <path
      d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M9.293,12.028a3.287,3.287,0,0,1,2.174.636,2.27,2.27,0,0,1,.756,1.841,2.555,2.555,0,0,1-.373,1.376,2.49,2.49,0,0,1-1.059.935A3.607,3.607,0,0,1,9.2,17.15H7.687v2.8H6.141V12.028ZM7.686,15.94H9.017a1.735,1.735,0,0,0,1.177-.351,1.3,1.3,0,0,0,.4-1.025q0-1.309-1.525-1.31H7.686V15.94Z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default DocumentPowerpointIcon;
